exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-login {\r\n    width: 100%;\r\n    max-width: 400px;\r\n    margin: 0 auto;\r\n    padding: 15px;\r\n}", ""]);

// exports
